<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
document.addEventListener("DOMContentLoaded", function () {
    // Replace this with the actual value of your goto parameter (e.g., from server or URL)
    const urlParams = new URLSearchParams(window.location.search);
    const my_id = urlParams.get('goto');

    if (my_id) {
        const targetElement = document.getElementById(my_id);
        if (targetElement) {
          
            if ( window.innerWidth < 768 ) {
              // console.log('mobile');
              var num =-1;
            }else{
              // console.log('desktop');
              var num = -1;
            }     
            const yOffset = num;
            const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;

            window.scrollTo({
                top: y,
                behavior: 'smooth'
            });
        }
    }
});


  
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}
$(document).ready(function() {

  if(window.location.hash == '#recover'){
    $("html, body").animate({ scrollTop: 100 }, "slow");
  }
  $('.forget-password,.cancel').click(function(){
    $("html, body").animate({ scrollTop: 100 }, "slow");
  });
  
  $("input[name='contact[phone]']").keypress(function(e) {
    var charCode = e.which ? e.which : event.keyCode;
    if (String.fromCharCode(charCode).match(/[^0-9+]/g)) return !1;
  });
  
});
// document.querySelector('.info-item.comment').addEventListener('click', function(e) {
//     e.preventDefault(); 
//     const targetId = this.getAttribute('href').substring(1); 
//     const targetElement = document.getElementById(targetId); 
//     if (targetElement) {
//         const topPosition = targetElement.offsetTop; 
//         window.scrollTo({
//             top: topPosition - 70,
//             behavior: 'smooth' 
//     })}
// });
